import type { Container } from 'pixi.js';
import { Player } from './player';

export class Player2 extends Player {
  constructor(stage: Container, x: number, y: number) {
    super(stage, x, y, { tint: 0xff44cc, useKeys: true });
  }
}
